module.exports = __webpack_public_path__ + "static/media/szymon.e75d719b.jpg";